import { useEffect, useState } from 'react'
import { resolveTemplateString } from '../helpers/resolve-template-string'
import { OpaqueSparqlResults } from '../helpers/sparqlResultHelpers'
import { useSparqlManager } from '../helpers/SparqlManager'
import { PublishToNamespace, usePubsub } from '../redux/pubsub'

export function SparqlTriggerExecutor(props: {
  endpoint: string
  sparqlTemplate: string
  templateId: string
  signalIsFetching?: (isFetching: boolean) => any
}) {
  const [vars, publish] = usePubsub()
  const [query, setQuery] = useState<string>()
  const sparqlManager = useSparqlManager(props.endpoint, props.templateId)

  useEffect(() => {
    try {
      const resolvedQuery = resolveTemplateString(props.sparqlTemplate, vars)
      setQuery(resolvedQuery)
    } catch(e) { console.error(e) }
  }, [props.endpoint, publish, vars, props.sparqlTemplate, props.templateId])

  useEffect(() => {
    if (!query || !sparqlManager) return
    (async () => {
      try {
        props.signalIsFetching?.(true)
        const response = await sparqlManager.fetch(query)
        props.signalIsFetching?.(false)
        if (!response.isLatest()) return

        publishResults(response.result, publish, `trigger ${props.templateId} -- update`)
      } catch(e) { console.error(e) }
    })()
  }, [sparqlManager, query]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => props.signalIsFetching?.(false)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

function publishResults(results: OpaqueSparqlResults, publish: PublishToNamespace, actionId: string) {
  const rows = results.results.bindings
  if (rows.length !== 1) throw new Error('got more than one result')

  for (const topic of results.head.vars) {
    publish(topic, rows[0][topic].value, actionId)
  }
}
